import ManageInspectionMonitorHome from './views/Home.vue'
import ManageInspectionMonitor from './views/Inspection.vue'
import ManageInspectionMonitorDetail from './views/InspectionDetail.vue'

export default {
  routes: [
    {
      path: '/manage/inspection_monitor',
      component: ManageInspectionMonitorHome,
      name: 'ManageInspectionMonitorHome',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'inspections',
          component: ManageInspectionMonitor,
          name: 'ManageInspectionMonitor',
        },
        {
          path: 'inspections/:id([0-9]+)',
          component: ManageInspectionMonitorDetail,
          name: 'ManageInspectionMonitorDetail',
          props: (route) => ({ id: Number(route.params.id) }),
        },
      ],
    },
  ],
}
